import { render, staticRenderFns } from "./PastDueByOffice.vue?vue&type=template&id=8cb6d452&scoped=true&"
import script from "./PastDueByOffice.vue?vue&type=script&lang=js&"
export * from "./PastDueByOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb6d452",
  null
  
)

export default component.exports